<template>
	<div class="container-wrap rtr_activity-exchange rtr_activity">
		<div class="container-box">
			<div v-if="mode === 'list'" class="">
				<div class="card">
					<h3 class="title">
						<img
							:src="iconExchangeDetailTitle"
							alt=""
							style="width: 24px; height: 24px"
						/>
						{{ $t('rtr_activity-exchange.title1') }}
					</h3>
				</div>
				<div class="card pt_40">
					<div
						:class="[
							'd_flex',
							'mb_20',
							isMobile ? 'flex_column' : 'align_items_end',
						]"
					>
						<div :class="['d_flex', isMobile ? 'mb_10' : '']">
							<div class="info mr_10">
								<p class="mb_10">{{ $t('rtr_activity.start') }}</p>
								<date-picker
									is-required
									v-model="startDate"
									:model-config="{ type: 'string' }"
									:locale="$store.state.common.locale"
								>
									<template v-slot="{ inputValue, inputEvents }">
										<label class="calendar_area">
											<input
												class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
												:value="inputValue"
												v-on="inputEvents"
											/>
										</label>
									</template>
								</date-picker>
							</div>
							<div class="info mr_10">
								<p class="mb_10">{{ $t('rtr_activity.end') }}</p>
								<date-picker
									is-required
									v-model="endDate"
									:model-config="{ type: 'string' }"
									:locale="$store.state.common.locale"
								>
									<template v-slot="{ inputValue, inputEvents }">
										<label class="calendar_area">
											<input
												class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
												:value="inputValue"
												v-on="inputEvents"
											/>
										</label>
									</template>
								</date-picker>
							</div>
						</div>
						<div class="select_area mr_10">
							<select
								v-model="assetSeq"
								:class="['asset_area', isMobile ? 'w100' : '']"
								@change="loadDirectTransferList('pageInit')"
							>
								<option :value="null">
									{{ $t('input.placeholder.all_assets') }}
								</option>
								<option
									v-for="item in accounts"
									:key="item.seq"
									:value="item.asset_seq"
									:label="item.asset_title"
								/>
							</select>
							<span class="select_icon"></span>
						</div>
					</div>
					<ul class="tab_area mb_20">
						<li
							:class="{ selected: selectedTab === 'ALL' }"
							@click="selectedTab = 'ALL'"
						>
							<a>{{ $t('rtr_activity-exchange.tab1') }}</a>
						</li>
						<li
							:class="{ selected: selectedTab === 'BID' }"
							@click="selectedTab = 'BID'"
						>
							<a>{{ $t('rtr_activity-exchange.tab2') }}</a>
						</li>
						<li
							:class="{ selected: selectedTab === 'ASK' }"
							@click="selectedTab = 'ASK'"
						>
							<a>{{ $t('rtr_activity-exchange.tab3') }}</a>
						</li>
					</ul>

					<div v-if="accountTransferList.length === 0" class="list_none">
						<span class="ERRORGRAY"></span>
						<p>{{ $t('rtr_activity-exchange.empty') }}</p>
					</div>

					<div v-else class="list">
						<div v-if="!isMobile" class="table-scroll-container">
							<table class="table_type">
								<thead>
									<tr>
										<th>{{ $t('rtr_activity-exchange.th1') }}</th>
										<th>{{ $t('rtr_activity-exchange.th2') }}</th>
										<th>{{ $t('rtr_activity-exchange.th3') }}</th>
										<th>{{ $t('rtr_activity-exchange.th4') }}</th>
										<th>{{ $t('rtr_activity-exchange.th5') }}</th>
										<th>{{ $t('rtr_activity-exchange.th6') }}</th>
										<th>{{ $t('rtr_activity-exchange.th7') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="item in accountTransferList"
										:key="item.seq"
										@click="showDetail(item)"
									>
										<td v-if="item.transfer_type === 'BID'">
											<span class="label_buy">{{
												$t('rtr_activity-exchange.buy')
											}}</span>
										</td>
										<td v-else>
											<span class="label_sell">{{
												$t('rtr_activity-exchange.sell')
											}}</span>
										</td>
										<td>
											{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
										</td>
										<td>
											{{ item.source_asset_code }} <br />
											{{ item.source_amount }}
										</td>
										<td>
											{{ item.target_asset_code }} <br />
											{{ item.target_amount }}
										</td>
										<td>{{ item.basic_rate }}</td>
										<td>{{ item.spread_rate }}</td>
										<td>{{ item.exchange_rate }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="isMobile" class="table_mobile">
							<div
								v-for="item in accountTransferList"
								:key="item.seq"
								class="table_item_mobile"
							>
								<div class="list_item_mobile">
									<div class="cont">
										<div class="list_title_box">
											<div class="date">
												{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
											</div>
											<div v-if="item.transfer_type === 'BID'">
												<span class="label_buy">{{
													$t('rtr_activity-exchange.buy')
												}}</span>
											</div>
											<div v-else>
												<span class="label_sell">{{
													$t('rtr_activity-exchange.sell')
												}}</span>
											</div>
										</div>
										<div class="list_info_box">
											<div class="item">
												<div>
													<p>{{ $t('rtr_activity-exchange.th3') }}</p>
													<div class="d_flex align_items_end">
														<p class="fs_16 mb_0">{{ item.source_amount }}</p>
														<p class="fs_12 ml_5 mb_0">
															{{ item.source_asset_code }}
														</p>
													</div>
												</div>
											</div>
											<div class="item">
												<div>
													<p>{{ $t('rtr_activity-exchange.th4') }}</p>
													<div class="d_flex align_items_end">
														<p class="fs_16 mb_0">{{ item.target_amount }}</p>
														<p class="fs_12 ml_5 mb_0">
															{{ item.target_asset_code }}
														</p>
													</div>
												</div>
											</div>
										</div>
										<div class="button_area">
											<button class="button_bg_blue" @click="showDetail(item)">
												{{ $t('button.detail') }}
											</button>
										</div>
										<div class="button_more_area">
											<div class="line"></div>
											<button @click="toggleMoreContent(item.seq)">
												<img
													:src="isItemOpen(item.seq) ? moreClose : more"
													alt="more"
													style="width: 24px; height: 24px"
												/>
											</button>
										</div>
									</div>
									<div class="more_cont" v-if="isItemOpen(item.seq)">
										<div class="list_info_box">
											<div class="item">
												<div>
													<p>{{ $t('rtr_activity-exchange.th5') }}</p>
													<p>{{ item.basic_rate }}</p>
												</div>
											</div>
											<div class="item">
												<div>
													<p>{{ $t('rtr_activity-exchange.th6') }}</p>
													<p>{{ item.spread_rate }}</p>
												</div>
											</div>
											<div class="item">
												<div>
													<p>{{ $t('rtr_activity-exchange.th7') }}</p>
													<p>{{ item.exchange_rate }}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<pagination
							:totalCount="pageNavigation.total_count"
							:totalPage="pageNavigation.total_page"
							:curPage="pageNavigation.cur_page"
							:point="pageNavigation.point"
							:firstPage="pageNavigation.first_page"
							:lastPage="pageNavigation.last_page"
							@change="pageChangeHandler"
						></pagination>
					</div>
				</div>
			</div>
			<ExchangeDetail
				v-if="mode === 'detail'"
				:exchangeInfo="exchangeInfo"
				@back="this.mode = 'list'"
			></ExchangeDetail>
		</div>
	</div>
</template>

<script>
import ExchangeDetail from '@/components/User/Activity/ExchangeDetail';
import { commonError } from '@/common/dialog';
import { mapGetters } from 'vuex';
import pagination from '@/components/Pagination';
import { fetchDirectTransfers } from '@/api/market';
import iconExchangeDetailTitle from '@/assets/images/v2/icon/icon-exchange-detail-title.svg';
import more from '@/assets/images/v2/icon/more.svg';
import moreClose from '@/assets/images/v2/icon/more-close.svg';

export default {
	name: 'Exchange',
	components: { ExchangeDetail, pagination },
	data() {
		return {
			selectedTab: 'ALL',
			accountTransferList: [],
			startDate: this.$dayjs(new Date()).add(-1, 'month').toDate(),
			endDate: new Date(),
			assetSeq: null,
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			mode: 'list',
			exchangeInfo: {},
			iconExchangeDetailTitle,
			isMobile: false,
			openedItems: [],
			more,
			moreClose,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
	},
	watch: {
		selectedTab() {
			this.loadDirectTransferList('pageInit');
		},
		startDate() {
			this.loadDirectTransferList('pageInit');
		},
		endDate() {
			this.loadDirectTransferList('pageInit');
		},
	},
	created() {
		this.assetSeq = this.$route.query.asset_seq || null;
		this.init();
		this.checkMobile();
	},
	mounted() {
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
		init() {
			this.loadDirectTransferList();
		},
		toggleMoreContent(itemSeq) {
			const index = this.openedItems.indexOf(itemSeq);
			if (index > -1) {
				this.openedItems.splice(index, 1);
			} else {
				this.openedItems.push(itemSeq);
			}
		},
		isItemOpen(itemSeq) {
			return this.openedItems.includes(itemSeq);
		},
		async loadDirectTransferList(type) {
			if (type === 'pageInit') {
				this.curPage = 1;
			}
			const params = {
				source_asset_seq: this.assetSeq,
				transfer_type: this.selectedTab === 'ALL' ? null : this.selectedTab,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchDirectTransfers(
				params,
			).catch(commonError);
			this.accountTransferList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadDirectTransferList();
		},
		showDetail(info) {
			this.exchangeInfo = info;
			this.mode = 'detail';
		},
	},
};
</script>
